<!-- <p>tour-agencias-confirmadas works!</p> -->

<ul class="nav nav-tabs">
    <li class="nav-item">
        <a class="nav-link active" [routerLink]="['/','admin', 'tours-confirmados']">Confirmados</a>
    </li>
    <li class="nav-item pe-2">
        <a class="nav-link" aria-current="page" [routerLink]="['/','admin', 'tours']">Reservados</a>
    </li>
    
</ul>
<div class="row">
    <div class="col-12 mt-4">
        <form [formGroup]="form" #f="ngForm" (ngSubmit)="onSubmit()" class="login">
            <div class="form-control p-0 position-relative">
                <input type="search" class="w-100 border-secondary" formControlName="search" placeholder="Buscar por agencia, pasajero o DNI">
                <img style="cursor: pointer;"  src="../assets/images/body/icons/search-icon.svg" class="position-absolute search-icon"  (click)="onSubmit()">
            </div>
        </form>
        <!-- <a href="javascript:history.back()" class="mt-5 mb-4 d-flex flex-row align-items-center text-decoration-none">
            <img src="../assets/images/body/icons/volver.svg" class="pe-2" alt="">
            <h4 class="text-primary mb-0"> Volver</h4>
        </a> -->
    </div>
    <!-- <div class="col-12 mt-4 d-flex">
        <div class="text-secondary rounded-pill border border-2 me-3 border-secondary btn-md btn-outline">
            Destino
        </div>
    </div> -->
</div>
<div *ngIf="paqueteReservado" class="d-flex align-items-baseline mt-5">
    <h2>{{paqueteReservado.destino}}</h2>
    <p class="mb-0 ps-3">{{paqueteReservado.fecha | date:'longDate'}}</p>
</div>
<h4 class="title-bg mt-4">Agencias confirmadas</h4>
<div class="mt-4">
    <div *ngFor="let item of filtered" class="pasajero-admin bg-light d-md-flex flex-wrap flex-lg-row align-items-center justify-content-between p-3 mb-3">
        <div class="d-flex align-items-center">
            <svg xmlns="http://www.w3.org/2000/svg" class="pe-3" width="50" height="50" viewBox="0 0 40 40"><g transform="translate(-120 -306)"><path d="M20,0h0A20,20,0,0,1,40,20v0A20,20,0,0,1,20,40H0a0,0,0,0,1,0,0V20A20,20,0,0,1,20,0Z" transform="translate(120 306)" class="fondo" fill="#00008b"/><path d="M16.789,16.789a5.394,5.394,0,1,0-5.394-5.394A5.393,5.393,0,0,0,16.789,16.789Zm0,2.7C13.188,19.486,6,21.293,6,24.88v2.7H27.577v-2.7C27.577,21.293,20.389,19.486,16.789,19.486Z" transform="translate(123.211 309.211)" class="icono" fill="#fff"/></g></svg>
            <h5 class="mb-0 text-center">{{item.nombre_agencia}}</h5>
        </div>
        <a style="cursor: pointer;"  (click)="verAgencia(item.id)" class="btn btn-lg rounded-pill btn-primary text-white text-center btn-reservar align-self-center">Ver info</a>
    </div>
</div>

<div class="row">
</div>

<div class="container">
    <div class="row mt-5">
        <div class="col-12 text-center">
        </div>
    </div>
</div>


    

   
    
